import { render, staticRenderFns } from "./InvoicePayment.vue?vue&type=template&id=60f1485d&scoped=true"
import script from "./InvoicePayment.vue?vue&type=script&lang=js"
export * from "./InvoicePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f1485d",
  null
  
)

export default component.exports